import {TeamService} from "../resource";

const TeamModule = {
	namespaced: true,
	state: {
		datas: [],
	},
	mutations: { 
		SET_DATA(state, data) {
			state.datas = data;
		}
	},
	actions: {
		createData({ commit, state }, data) {
			return TeamService.TeamCreate(data);
		},

		updateData({ commit, state }, data) {
			return TeamService.TeamUpdate(data.id,data.payload);
		},

		deleteData({ commit, state }, data) {
			return TeamService.TeamDelete(data);
		},

		async listData({ commit, state }, data) {
			try
			{
				const response = await TeamService.TeamList(data);
				commit("SET_DATA", response.data.Data);
			}
			catch (error)
			{
				commit("SET_DATA", []);
			}
		}
	},
	getters: {
		getData(state) {
			return state.datas;
		}
	},
};

export default TeamModule;